/**
 * @file   介绍
 * @create macaiqi 2025/08/15
 * @update 
 */
import React, { useEffect, useState } from 'react'
import { queryArchivesById } from '../../service';
// import { htmltoStr } from '../../utils';


export default function Introduce({ showqin, setShowQin }) {
    const [data, setData] = useState()
    const [show, setShow] = useState();
    useEffect(() => {
        queryArchivesById(showqin).then(res => {
            setData(res)
        })
    }, [showqin])

    // 正则匹配中文引号（“”或""）
    const quotedText = data?.title.replace(/“([^”]+)”|"([^"]+)"|（([^）]+)）|\(([^)]+)\)/g, (match, p1, p2, p3, p4) => {
        const content = p1 || p2 || p3 || p4; // 获取引号或括号内的内容
        // 判断原始匹配的是哪种引号/括号，以决定使用哪种替换符号
        if (p1 || p2) {
            // 如果是英文引号或中文引号
            return `
        <span class="rotated-quote">『</span>
        ${content}
        <span class="rotated-quote">』</span>
        `;
        } else if (p3 || p4) {
            // 如果是中文括号（） 英文括号()
            return `
        <span class="rotated-quote">（</span>
        ${content}
        <span class="rotated-quote">）</span>
        `;
        }
    });
    return (
        <div className='common-page introduce-page'>
            <div className="title" dangerouslySetInnerHTML={{ "__html": quotedText }}>
            </div>
            {data?.linkUrl && <div className='three' onClick={() => {
                setShow("3d")
            }} />}
            <img src={window.ENV_IMG_PREURL + data?.imgSrc} alt="" srcset="" className='qinimg' />
            <div className="contentbox" >
                <div className="scroll" dangerouslySetInnerHTML={{ "__html": data?.content }} />
            </div>
            <div
                className="back"
                onClick={() => {
                    setShowQin()
                }}></div>


            {show === "3d" && (
                <div className="common-page">
                    <iframe src={window.QINLINK ? window.QINLINK + "?" + data?.linkUrl?.split("?")?.[1] : data?.linkUrl} title="pdf" frameBorder={0} />
                    <div
                        className="iframeclose"
                        onClick={() => {
                            setShow()
                        }}></div>
                </div>
            )}
        </div >
    )
}
